function hashEmail(email) {
  const norm = String(email || "")
    .toLowerCase()
    .trim();
  let hash = 0;
  for (let i = 0; i < norm.length; i++) {
    hash = norm.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
}

/** Color estable y distinguible por dirección de cuenta. */
export function accountColor(email) {
  if (!email || !String(email).includes("@")) return "#64748b";
  const hue = hashEmail(email) % 360;
  return `hsl(${hue}, 62%, 40%)`;
}

function parseHsl(color) {
  const match = color.match(/hsl\((\d+),\s*(\d+)%,\s*(\d+)%\)/);
  if (!match) return null;
  return { h: Number(match[1]), s: Number(match[2]), l: Number(match[3]) };
}

/** Estilos de chip para la cuenta receptora en listas. */
export function accountChipSx(email, neutral = {}) {
  if (!email || !String(email).includes("@")) {
    return {
      bgcolor: neutral.metaBg || "rgba(100, 116, 139, 0.1)",
      borderColor: neutral.border || "rgba(100, 116, 139, 0.28)",
      color: neutral.textMuted || "#64748b",
      fontWeight: 600,
    };
  }

  const color = accountColor(email);
  const hsl = parseHsl(color);
  if (!hsl) {
    return { color, fontWeight: 700 };
  }

  return {
    bgcolor: `hsla(${hsl.h}, ${hsl.s}%, ${hsl.l}%, 0.14)`,
    borderColor: `hsla(${hsl.h}, ${hsl.s}%, ${hsl.l}%, 0.4)`,
    color,
    fontWeight: 700,
  };
}
